import { gql } from '@apollo/client';
import { ExternalIdFilter } from 'gql-types';

import type { ExternalIdFragment } from './externalId.gql.types';

export type { ExternalIdFragment };

export namespace ExternalId {
    /** @deprecated Use ExternalIdFilter imported from 'gql-types' */
    export type Filters = ExternalIdFilter;
}

export const EXTERNAL_ID_FRAGMENT = gql`
    fragment ExternalId on ExternalId {
        system
        type
        value
    }
`;

// Convenience utility for mid-migration checks about whether there is an external ID between the old and new external ID types.
export const hasExternalId = (
    externalId: string | null,
    externalIds: ExternalIdFragment[] | null,
): boolean => {
    return !(!externalId && externalIds?.length === 0);
};

export const existsInExternalSystem = (
    externalId: string | null,
    externalIds: ExternalIdFragment[] | null,
): boolean => Boolean(externalId) || Boolean(externalIds && externalIds.length > 0);
